import stationDataService from "@/api/rest-telemetric/station-data.service";
import lightningCounterService from "@/api/rindat-api/lightning-counter.service";
import moment from "moment";

const state = {
  regionals: [],
  regionalsLightningCount: [],
  regionalStationData: [],
  regionalStationDataLoading: false,
  lightningLoading: false,
};

const mutations = {
  setRegionals(state, data) {
    state.regionals = data ? data : [];
  },
  setRegionalsLightningCount(state, data) {
    data.map((el) => {
      state.regionals.forEach((elState) => {
        if (el.regionalId == elState.id) {
          el.name = elState.fullname;
        }
      });
    });
    state.regionalsLightningCount = data ? data : [];
  },
  setRegionalStationData(state, data) {
    state.regionalStationData = data ? data : [];
  },
  setRegionalStationLoading(state, data) {
    state.regionalStationDataLoading = data;
  },
  setLightningLoading(state, data) {
    state.lightningLoading = data;
  },
};

const actions = {
  fetchRegionals({ commit }) {
    const regionals = [
      {
        id: 88,
        name: "DOCCMN",
        fullname: "DOCCMN",
        icon: "",
      },
      {
        id: 89,
        name: "DOCCSL",
        fullname: "DOCCSL",
        icon: "",
      },
      {
        id: 90,
        name: "DOCMSL",
        fullname: "DOCMSL",
        icon: "",
      },
      {
        id: 91,
        name: "DOCNRO",
        fullname: "DOCNRO",
        icon: "",
      },
      {
        id: 92,
        name: "DOCNRT",
        fullname: "DOCNRT",
        icon: "",
      },
      {
        id: 93,
        name: "DOCOST",
        fullname: "DOCOST",
        icon: "",
      },
      {
        id: 94,
        name: "DOCSUD",
        fullname: "DOCSUD",
        icon: "",
      },
    ];
    commit("setRegionals", regionals);
  },
  async fetchRegionalsLightningCount({ commit }, data) {
    commit("setLightningLoading", true);
    const ids = [];
    data.forEach((el) => {
      ids.push(el.id);
    });
    const response = await lightningCounterService.getRegionalLightningCounter(
      ids.toString(),
      moment().utc().toISOString(),
      60
    );
    commit("setRegionalsLightningCount", response.data);
    commit("setLightningLoading", false);
  },

  async fetchRegionalStationData({ commit }, data) {
    commit("setRegionalStationLoading", true);
    const ids = [];
    data.forEach((el) => {
      ids.push(el.id);
    });
    const response = await stationDataService.getRegionalStationData(
      ids.toString()
    );
    let res = response.data;
    let array = [];
    if (res && res.length > 0) {
      res.forEach((e) => {
        if (!array.some((el) => el.regId == e.regionalId)) {
          let name = "";
          switch (e.regionalId) {
            case 88:
              name = "DOCCMN";
              break;
            case 89:
              name = "DOCCSL";
              break;
            case 90:
              name = "DOCMSL";
              break;
            case 91:
              name = "DOCNRO";
              break;
            case 92:
              name = "DOCNRT";
              break;
            case 93:
              name = "DOCOST";
              break;
            case 94:
              name = "DOCSUD";
              break;
            default:
              break;
          }
          array.push({
            regId: e.regionalId,
            name: name,
            alerts: [],
          });
        }
      });
      res.forEach((el1) => {
        array.map((el2) => {
          if (el1.regionalId == el2.regId) {
            if (el1.windGust) {
              el2.alerts.push(el1);
            }
          }
        });
      });
      commit("setRegionalStationData", array);
    }
    commit("setRegionalStationLoading", false);
  },
};

const getters = {
  regionalsList: (state) => state.regionals,
  regionalsLightningCountList: (state) => state.regionalsLightningCount,
  regionalStationDataList: (state) => state.regionalStationData,
  regionalStationDataLoading: (state) => state.regionalStationDataLoading,
  lightningLoading: (state) => state.lightningLoading,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
